module.exports = __webpack_public_path__ + "img/basque-country.957267be.svg";